const translations = {
  "en": {
    "Are you missing year-end tax moves?": "Are you missing year-end tax moves?",
    "Can you actually afford a home?": "Can you actually afford a home?",
    "Does your portfolio match your risk appetite?": "Does your portfolio match your risk appetite?",
    "Earning a lot but keeping none of it?": "Earning a lot but keeping none of it?",
    "How close are you to your down payment?": "How close are you to your down payment?",
    "How long could you last with no income?": "How long could you last with no income?",
    "How much are you overpaying the IRS?": "How much are you overpaying the IRS?",
    "Is one stock running your whole future?": "Is one stock running your whole future?",
    "Is your cash just sitting there?": "Is your cash just sitting there?",
    "Is your employer also your biggest investment?": "Is your employer also your biggest investment?",
    "Is your safety net actually a net?": "Is your safety net actually a net?",
    "One bad month away from trouble?": "One bad month away from trouble?",
    "Pay down debt, or invest it?": "Pay down debt, or invest it?",
    "Rent or buy — which is smarter for you?": "Rent or buy — which is smarter for you?",
    "Where is your money actually leaking?": "Where is your money actually leaking?",
    "Will your RSUs leave a surprise tax bill?": "Will your RSUs leave a surprise tax bill?"
  },
  "zh-tw": {
    "Are you missing year-end tax moves?": "你錯過年底的稅務操作了嗎？",
    "Can you actually afford a home?": "你真的負擔得起一棟房子嗎？",
    "Does your portfolio match your risk appetite?": "你的投資組合是否符合你的風險承受能力？",
    "Earning a lot but keeping none of it?": "賺很多卻留不住？",
    "How close are you to your down payment?": "你離頭期款還差多少？",
    "How long could you last with no income?": "如果你沒有收入，你能撐多久？",
    "How much are you overpaying the IRS?": "你多付了多少稅給國稅局？",
    "Is one stock running your whole future?": "一隻股票會決定你的一生嗎？",
    "Is your cash just sitting there?": "你的現金只是閒置在那裡嗎？",
    "Is your employer also your biggest investment?": "你的雇主也是你最大的投資嗎？",
    "Is your safety net actually a net?": "你的安全網真的是一張網嗎？",
    "One bad month away from trouble?": "一個壞月份就會惹上麻煩？",
    "Pay down debt, or invest it?": "償還債務，還是投資？",
    "Rent or buy — which is smarter for you?": "租還是買 — 哪一種對你更明智？",
    "Where is your money actually leaking?": "你的錢實際上是從哪裡流失的？",
    "Will your RSUs leave a surprise tax bill?": "你的 RSU 會帶來意外的稅單嗎？"
  }
};

export default translations;
